// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "./TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "./CrossIcon.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as PilotRadioButtonMultiChoice$LiteracyplanetTupperware from "../v3/PilotRadioButtonMultiChoice.res.mjs";
import * as SkilfulMultiChoiceSingleResponseContainer$LiteracyplanetTupperware from "./SkilfulMultiChoiceSingleResponseContainer.res.mjs";

function SkilfulRadioButtonMultiChoice$Radio(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.Radio.className
            }, React.createElement("div", {
                  className: "SkilfulRadioButtonMultiChoice-RadioSelection"
                }));
}

var Radio = {
  make: SkilfulRadioButtonMultiChoice$Radio
};

function SkilfulRadioButtonMultiChoice$Skilful(props) {
  return React.createElement(SkilfulMultiChoiceSingleResponseContainer$LiteracyplanetTupperware.make, {
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: React.createElement("div", {
                    className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.className
                  }, React.createElement(SkilfulRadioButtonMultiChoice$Radio, {}), props.children, React.createElement("div", undefined, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                            className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.CorrectMarkIcon.className
                          }), React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                            className: Skillet$LiteracyplanetTupperware.SkilfulRadioButtonMultiChoice.IncorrectMarkIcon.className
                          })))
            });
}

var Skilful = {
  make: SkilfulRadioButtonMultiChoice$Skilful
};

function SkilfulRadioButtonMultiChoice(props) {
  var children = props.children;
  var responseOptionId = props.responseOptionId;
  var questionIndex = props.questionIndex;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotRadioButtonMultiChoice$LiteracyplanetTupperware.make, {
                questionIndex: questionIndex,
                responseOptionId: responseOptionId,
                children: children
              });
  } else {
    return React.createElement(SkilfulRadioButtonMultiChoice$Skilful, {
                questionIndex: questionIndex,
                responseOptionId: responseOptionId,
                children: children
              });
  }
}

var make = SkilfulRadioButtonMultiChoice;

var $$default = SkilfulRadioButtonMultiChoice;

export {
  Radio ,
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
